import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { tap, catchError, Observable, map, take, of } from 'rxjs';

import { LoggerService } from './utils/logger.service';
import { environment } from '../../../environments/environment';
import { IUser } from '../../shared/models/be/user';
import { RequestsService } from './utils/requests.service';
//import { DeviceSpecs, LocalUserDevices, UserDevices } from 'src/app/shared/models/user-devices';

@Injectable({
    providedIn: 'any'
})
export class SupportService {

    constructor(
        private loggerService: LoggerService,
        private _http: HttpClient
    ) { }

    public getServiceStatus$(): Observable<boolean> {
        return this._http.get<{ message: string }>(`${environment.apiEndpoint}/users/ping`).pipe(
            take(1),
            map((val: { message: string }) => !!val.message),
            catchError(err => {
                this.loggerService.error('Error on .../ping')
                return of(false);
            })
        );
    }

    public createSupportTicket$(data: any) {
        return this._http.post(
            `${environment.apiEndpoint}/support`,
            data
        ).pipe(
            take(1),
            catchError(err => {
                throw `error in source. Details:  + ${err}`
            })
        );
    }

    public getTicketsList$(): Observable<any> {
        return this._http.get<any>(`${environment.apiEndpoint}/support`).pipe(
            take(1),
            catchError(err => {
                throw `error in source. Details:  + ${err}`
            })
        );
    }
}
